// Inline summary editor for talents#show. Edit → textarea → Save PATCHes
// the JSON summary endpoint and swaps server-rendered simple_format HTML
// back into the view. Generalize to inline-edit-controller if we grow more
// single-column inline edits.

import { Controller } from "@hotwired/stimulus";
import { jsonHeader } from '../jssrc/base_ext.js';
import i18n from '../jssrc/i18n_js_with_locales';

export default class extends Controller {
    static targets = ["view", "form", "input"]
    static values = { url: String, raw: String, empty: String }

    edit(event){
        event.preventDefault();
        // Reseed on every open so Cancel + reopen discards in-progress edits.
        this.inputTarget.value = this.rawValue;
        this.#show_form();
        this.inputTarget.focus();
    }

    cancel(event){
        event.preventDefault();
        this.#show_view();
    }

    async save(event){
        event.preventDefault();
        this.#set_busy(true);
        try {
            const csrf = document.querySelector('meta[name="csrf-token"]')?.content;
            const res = await fetch(this.urlValue, {
                method: 'PATCH',
                credentials: 'same-origin',
                headers: { ...jsonHeader(), 'X-CSRF-Token': csrf },
                body: JSON.stringify({ talent: { summary: this.inputTarget.value } })
            });
            if (!res.ok) {
                let msg = i18n.t('common.something_went_wrong');
                try {
                    const err = await res.json();
                    if (err.errors?.[0]) msg = err.errors[0];
                } catch (_) { /* not JSON */ }
                alert(msg);
                return;
            }
            const data = await res.json();
            this.rawValue = data.summary || '';
            this.#render_view(data.summary, data.summary_html);
            this.#show_view();
        } finally {
            this.#set_busy(false);
        }
    }

    #render_view(text, html){
        if (text && text.length > 0) {
            // simple_format() output from the server; safe to insert.
            this.viewTarget.innerHTML = `<div class="tl-p-summary">${html || ''}</div>`;
        } else {
            const empty = document.createElement('div');
            empty.className = 'tl-p-summary is-empty';
            empty.textContent = this.emptyValue || '';
            this.viewTarget.replaceChildren(empty);
        }
    }

    #show_form(){
        this.formTarget.classList.remove('d-none');
        this.viewTarget.classList.add('d-none');
    }

    #show_view(){
        this.formTarget.classList.add('d-none');
        this.viewTarget.classList.remove('d-none');
    }

    #set_busy(busy){
        this.element.querySelectorAll('button').forEach(b => b.disabled = busy);
    }
}
